import React, { useState, useEffect } from 'react';
import { useUser } from '../../Context/UserContext';
import { getAddressList, deleteAddressById } from '../../Api/AddressApi'
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import { ruRU } from '@mui/x-data-grid/locales'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import s from "./SettingData.module.css"
import { AlertBar } from '../shared/AlertBar';
import { AddressEditForm, AddressForm} from '../Forms/AddressForm';
import { ModalTemplate } from "../shared/ModalForms";

function AddressTable() {
    const [open, setOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ severity: 'info', message: '' });
    const { user } = useUser();
    const [editingAddress, setEditingAddress] = useState({});
    const [data, setData] = useState([])
    const { t } = useTranslation();
    const [openAddress, setOpenAddress] = useState(false);
    const handleOpenAddress = () => setOpenAddress(true);
    const handleCloseAddress = () => setOpenAddress(false);

    const [openEditAddress, setOpenEditAddress] = useState(false);
    const handleOpenEditAddress = () => setOpenEditAddress(true);
    const handleCloseEditAddress = () => setOpenEditAddress(false);

    const theme = createTheme(
        ruRU
    );

    useEffect(() => {
        async function fetchData() {
            try {
                const data = await getAddressList();
                setData(data);
            } catch (error) {
                console.error('Error fetching address list:', error.message);
            }

        }

        fetchData();
    }, [user, alertInfo]);

    const deleteAddress = async (id, countDevice) => {
        try {
            if (countDevice > 0) {
                setAlertInfo({ severity: 'error', message: t('deleteFalse') });
                setOpen(true);
                return;
            }

            await deleteAddressById(id);

            setAlertInfo({ severity: 'success', message: t('deleteTrue') });
            setOpen(true);
            await fetchData();

        } catch (error) {
            console.error('Error deleting address:', error);
            setAlertInfo({ severity: 'error', message: t('deleteError') });
            setOpen(true);
        }
    }

    const editAddress = (_id, _group) => {
        setEditingAddress({ id: _id, group: _group });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSuccess = (data) => {
        handleCloseEditAddress();
        setAlertInfo(data);
        setOpen(true);
    };

    const rows = data.map(item => ({
        id: item._id,
        countDevice: item.device_count,
        country: item.country,
        region: item.region,
        city: item.city,
        street: item.street,
        building: item.building,
        latlng: `${item.lat},${item.lng}`
    }))

    const columns = [
        { field: 'countDevice', headerName: t('countDevice'), width: 120 },
        { field: 'country', headerName: t('country'), width: 130 },
        { field: 'region', headerName: t('region'), width: 150 },
        { field: 'city', headerName: t('city'), width: 160 },
        { field: 'street', headerName: t('street'), width: 160 },
        { field: 'building', headerName: t('building'), width: 100 },
        { field: 'latlng', headerName: t('latlng'), width: 160 },
        {
            field: 'action',
            headerName: t('action'),
            width: 100,
            sortable: false,
            renderCell: (params) => (

                <div className={s.action}>
                    <div className={s.actEditButton} onClick={(event) => {
                        event.stopPropagation();
                        editAddress(params.row.id);
                        handleOpenEditAddress();
                    }}>
                        <EditIcon />
                    </div>
                    <div className={s.actDelButton} onClick={() => { deleteAddress(params.row.id, params.row.countDevice) }}>
                        <DeleteIcon />
                    </div>
                </div>
            ),
        },
    ];



    return (
        <ThemeProvider theme={theme}>
            <AlertBar open={open} handleClose={handleClose} message={alertInfo.message} severity={alertInfo.severity} />
            <ModalTemplate
                open={openAddress}
                onClose={handleCloseAddress}
            >
                <AddressForm onSuccess={handleCloseAddress} />
            </ModalTemplate>

            <Box sx={{ width: '100%' }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    sx={{
                        marginBottom: 1
                    }}
                    onClick={handleOpenAddress}
                >
                    {t('createAddress')}
                </Button>
                <Box sx={{ width: '100%', overflowX: 'auto' }}>
                    <DataGrid
                        columns={columns}
                        rows={rows}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        autoHeight
                        pageSizeOptions={[10, 20, 50, 100]}
                        sx={{
                            "& p": {
                                marginTop: "auto",
                                marginBottom: "1rem",
                            },
                        }}
                    />
                </Box>
                <ModalTemplate
                    open={openEditAddress}
                    onClose={handleCloseEditAddress}
                >

                    <AddressEditForm onSuccess={handleSuccess} changeData={editingAddress}></AddressEditForm>

                </ModalTemplate>
            </Box>
        </ThemeProvider>
    )



}

export default AddressTable;

